module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1211"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1211"
    },
    "bundlingPackage": "LoginUI",
    "bundlingPackageVersion": "static-1.15699",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};